import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import {
  AdminPermissionNamesEnum,
  DEFAULT_ADMIN_USER_PERMISSIONS
} from '../../(dashboards)/admin-users/constants'

const initialState: AdminUser = {
  AdminUserID: -1,
  Name: '',
  Email: '',
  CreatedAtUTC: '',
  MFAMandatory: false,
  AuthURL: '',
  AuthenticatorSet: false,
  Suspended: false,
  Permissions: DEFAULT_ADMIN_USER_PERMISSIONS,
  PermissionName: AdminPermissionNamesEnum.ALL_DISABLED
}

export const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {
    setAdminUserInfo: (state, action: PayloadAction<AdminUser>) => {
      return action.payload
    }
  }
})

export const { setAdminUserInfo } = adminUserSlice.actions
export const adminUserReducer = adminUserSlice.reducer
